<div *ngIf="displayDashboard" class="animation-fade-in animation-duration-240s">
	<div class="p-grid w-100 d-flex justify-content-between">
		<div class="p-col-12 p-md-6 p-lg-4">
			<div class="card no-gutter widget-overview-box widget-overview-box-1">
				<div class="d-flex">
					<span class="overview-icon">
						<fa-icon [icon]="['far', 'envelope-open-dollar']"></fa-icon>
					</span>
					<span class="overview-title">Current Batch Amount</span>
				</div>
				<div class="p-grid overview-detail">
					<div class="p-col">
						<div class="overview-number">
							<p-skeleton *ngIf="!currentDayBatchRecord"></p-skeleton>
							<span *ngIf="currentDayBatchRecord">
								{{ currentDayBatchRecord.amount | currency }}
							</span>
						</div>
						<div class="overview-subtext">Current amount pending settlement</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-6 p-lg-4">
			<div class="card no-gutter widget-overview-box widget-overview-box-1">
				<div class="d-flex">
					<span class="overview-icon">
						<fa-icon [icon]="['far', 'hashtag']"></fa-icon>
					</span>
					<span class="overview-title">Transactions</span>
				</div>
				<div class="p-grid overview-detail">
					<div class="p-col">
						<div class="overview-number">
							<p-skeleton *ngIf="!currentDayBatchRecord"></p-skeleton>
							<span *ngIf="currentDayBatchRecord">
								{{ currentDayBatchRecord.transactionCount }}
							</span>
						</div>
						<div class="overview-subtext">Quantity of transaction in open batch</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-6 p-lg-4">
			<div class="card no-gutter widget-overview-box widget-overview-box-1">
				<div class="d-flex">
					<span class="overview-icon">
						<fa-icon [icon]="['far', 'credit-card-front']"></fa-icon>
					</span>
					<span class="overview-title">Last Transaction</span>
				</div>
				<div class="p-grid overview-detail">
					<div class="col-4">
						<div class="overview-number">
							<p-skeleton *ngIf="!currentDayBatchRecord"></p-skeleton>
							<span *ngIf="currentDayBatchRecord">
								<ng-container *ngIf="!currentDayBatchRecord.transactions"> --- </ng-container>
								<ng-container *ngIf="currentDayBatchRecord.transactions">
									{{
										app
											.moment(currentDayBatchRecord.transactions[currentDayBatchRecord.transactions.length - 1].Summary.TimeStamp)
											.format('LT')
									}}
								</ng-container>
							</span>
						</div>
						<div class="overview-subtext">Time</div>
					</div>
					<div class="col-4">
						<div class="overview-number">
							<p-skeleton *ngIf="!currentDayBatchRecord"></p-skeleton>
							<span *ngIf="currentDayBatchRecord">
								<ng-container *ngIf="!currentDayBatchRecord.transactions"> --- </ng-container>
								<ng-container *ngIf="currentDayBatchRecord.transactions">
									{{ currentDayBatchRecord.transactions[currentDayBatchRecord.transactions.length - 1].Summary.Amount | currency }}
								</ng-container>
							</span>
						</div>
						<div class="overview-subtext">Amount</div>
					</div>
					<div class="col-4">
						<div class="overview-number">
							<p-skeleton *ngIf="!currentDayBatchRecord"></p-skeleton>
							<span *ngIf="currentDayBatchRecord">
								<ng-container *ngIf="!currentDayBatchRecord.transactions"> --- </ng-container>
								<ng-container *ngIf="currentDayBatchRecord.transactions">
									{{ currentDayBatchRecord.transactions[currentDayBatchRecord.transactions.length - 1].Summary.LastFour }}
								</ng-container>
							</span>
						</div>
						<div class="overview-subtext">
							<p-skeleton *ngIf="!currentDayBatchRecord"></p-skeleton>
							<span *ngIf="currentDayBatchRecord">
								<ng-container *ngIf="!currentDayBatchRecord.transactions"> --- </ng-container>
								<ng-container *ngIf="currentDayBatchRecord.transactions">
									<fa-icon
										*ngIf="currentDayBatchRecord.transactions[currentDayBatchRecord.transactions.length - 1].Summary.CardBrand === 'VISA'"
										[icon]="['fab', 'cc-visa']"
										size="2x"
									></fa-icon>
									<fa-icon
										*ngIf="currentDayBatchRecord.transactions[currentDayBatchRecord.transactions.length - 1].Summary.CardBrand === 'AMEX'"
										[icon]="['fab', 'cc-amex']"
										size="2x"
									></fa-icon>
									<fa-icon
										*ngIf="currentDayBatchRecord.transactions[currentDayBatchRecord.transactions.length - 1].Summary.CardBrand === 'DCVR'"
										[icon]="['fab', 'cc-discover']"
										size="2x"
									></fa-icon>
									<fa-icon
										*ngIf="currentDayBatchRecord.transactions[currentDayBatchRecord.transactions.length - 1].Summary.CardBrand === 'M/C'"
										[icon]="['fab', 'cc-mastercard']"
										size="2x"
									></fa-icon>
								</ng-container>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
